import { DocumentReference } from "firebase/firestore";

import { ExamTypeMode } from "./ExamTypeMode";
import { FirestoreOfflineDocument } from "@/core/modules/firestore/objects/FirestoreOfflineDocument";

import { EnumField, NumberWithDefaultField, StringField } from "@/core/fields";

export class ExamType extends FirestoreOfflineDocument {
  public name: string | undefined = undefined;
  public frequency = 999;
  public mode: ExamTypeMode = ExamTypeMode.Recurring;
  public order = 999;

  public constructor(firestoreData?: Record<string, unknown>, id?: string) {
    super(id);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData, id);
  }

  public fromFirestore(data: Record<string, unknown>, id?: string, firestoreRef?: DocumentReference): ExamType {
    super.fromFirestore(data, id, firestoreRef);

    this.name = StringField.fromFirestore(data.name);
    this.frequency = NumberWithDefaultField.fromFirestore(data.frequency, 999);
    this.mode = EnumField.fromFirestore<ExamTypeMode>(data.mode, Object.values(ExamTypeMode), ExamTypeMode.Recurring);
    this.order = NumberWithDefaultField.fromFirestore(data.order, 999);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.name = StringField.toFirestore(this.name);
    firestoreData.frequency = NumberWithDefaultField.toFirestore(this.frequency, 999);
    firestoreData.mode = EnumField.toFirestore<ExamTypeMode>(this.mode, ExamTypeMode.Recurring);
    firestoreData.order = NumberWithDefaultField.toFirestore(this.order, 999);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): ExamType {
    super.fromOfflineCache(data);

    this.name = StringField.fromOfflineCache(data.name);
    this.frequency = NumberWithDefaultField.fromOfflineCache(data.frequency, 999);
    this.mode = EnumField.fromOfflineCache<ExamTypeMode>(data.mode, Object.values(ExamTypeMode), ExamTypeMode.Recurring);
    this.order = NumberWithDefaultField.fromOfflineCache(data.order, 999);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.name = StringField.toOfflineCache(this.name);
    firestoreData.frequency = NumberWithDefaultField.toOfflineCache(this.frequency, 999);
    firestoreData.mode = EnumField.toOfflineCache<ExamTypeMode>(this.mode, ExamTypeMode.Recurring);
    firestoreData.order = NumberWithDefaultField.toOfflineCache(this.order, 999);

    return firestoreData;
  }
}
